import clsx from "clsx";
import { ReactComponent as InfoSvg } from "assets/Svgs/InfoSvg.svg";
import { ReactComponent as TimeLapseSvg } from "assets/Svgs/TimeLapseSvg.svg";
import { getHighlightedText, truncateWithEllipses } from "utils/helper";
import { NotificationStatus, NotificationType } from "assets";
import {
  GetNotificationBorderColor,
  NotificationTypeUpdated,
  getProgressStatus,
  getTypeColor,
} from "shared-functions/notification";
import { useNavigate } from "react-router-dom";
import TypeBadge from "./TypeBadge";
import { Tooltip } from "@mui/material";
import { useBoundStore } from "store/store";

interface NotificationCardItemProps {
  text: string;
  statusColor: string;
  status: string;
  btColor: string;
  type: string;
  notification: any;
  showHighlightedText?: boolean;
  searchKeyword?: string;
  equipmentNodeId: string;
}

function NotificationCardItem(props: NotificationCardItemProps) {

  let lang:any = useBoundStore((state => state.lang));

  const navigate = useNavigate();
  return (
    <div
      className={clsx("notificationCardItem", " bxShadow cp")}
      style={{ height: "80px" }}
      onClick={() => {
        navigate("/notification-details", {
          state: {
            nodeid: props?.notification.nodeid,
            equipmentNodeId: props?.equipmentNodeId,
          },
        });
      }}
    >
      <div className="_content">
        <div style={{ backgroundColor: props.btColor }}></div>
        <div className="mainContent">
          <div className="_title">
            <Tooltip title={"" + props.text}>
              <div className="_titleText truncate">
                {props?.showHighlightedText
                  ? getHighlightedText(props.text, props?.searchKeyword)
                  : props.text}
              </div>
            </Tooltip>

            <TypeBadge
              typecode={+props.type}
              notification={props.notification}
            />
          </div>

          <div className="_stats">
            <div
              className="_iconWithText"
              style={{
                paddingTop: "6px",
              }}
            >
              <InfoSvg /> {NotificationStatus(Number(props.status), lang)}
            </div>
            <div
              className="_iconWithText"
              style={{
                paddingTop: "6px",
              }}
            >
              <TimeLapseSvg />
              {getProgressStatus(props.notification,lang)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotificationCardItem;
